export const riverSeaRoutes = [
  {
    path: "/river_sea/officialApplication",
    name: "officialApplication",
    meta: {
      isKeepAlive: false,
      title: "官方应用",
    },
    component: () =>
      import("@/components/river_sea/officialApplication/index.vue"),
  },
  {
    path: "/river_sea/port_EDI",
    name: "port_EDI",
    meta: {
      isKeepAlive: false,
      title: "港航EDI",
    },
    component: () => import("@/components/river_sea/port_EDI/index.vue"),
  },
  {
    path: "/river_sea/river_sea",
    name: "river_sea",
    meta: {
      isKeepAlive: false,
      title: "江海联运",
    },
    component: () => import("@/components/river_sea/river_sea/index.vue"),
  },
  {
    path: "/river_sea/ship_trace",
    name: "ship_trace",
    meta: {
      isKeepAlive: false,
      title: "船期追踪",
    },
    component: () => import("@/components/river_sea/ship_trace/index.vue"),
  },
  {
    path: "/river_sea/company",
    name: "company",
    meta: {
      isKeepAlive: false,
      title: "企业黄页",
    },
    component: () => import("@/components/river_sea/company/index.vue"),
  },
  {
    path: "/river_sea/company_detail",
    name: "companyDetail",
    meta: {
      isKeepAlive: false,
      title: "企业详情",
    },
    component: () => import("@/components/river_sea/company_detail/index.vue"),
  },
  {
    path: "/river_sea/resource",
    name: "resource",
    meta: {
      isKeepAlive: false,
      title: "港航资源",
    },
    component: () => import("@/components/river_sea/resource/index.vue"),
  },
];
